import React from 'react';
import Logo from '../../components/Logo';
import Footer from '../../components/Footer';
import WalletMenu from '../../components/WalletMenu';
import NavigationMenu from '../../components/NavigationMenu';

export default function TermsConditions() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-gray-50 to-white border-b border-gray-100">
        <div className="max-w-8xl mx-auto">
          <div className="flex items-center justify-between py-4 px-6">
            <div className="flex items-center gap-8">
              <Logo />
              <NavigationMenu />
            </div>
            <div className="flex items-center gap-4">
              <WalletMenu onShowDashboard={() => {}} />
            </div>
          </div>
        </div>
      </header>

      <main className="flex-1 pt-[88px]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-2xl shadow-lg p-8 space-y-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold">Terms & Conditions</h1>
              <p className="text-gray-600 mt-2">Last Updated: March 9, 2025</p>
            </div>

            <section className="space-y-6">
              <div className="space-y-4">
                <h2 className="text-xl font-semibold">Welcome to PrivatecharterX</h2>
                <p className="text-gray-600">
                  At PrivatecharterX, we aim to offer a transparent and secure charter experience. Our terms align with industry standards established by leading operators and include important Web3 and crypto-compliant updates for blockchain-based booking systems.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">1. Booking Process</h2>
                <p className="text-gray-600">
                  Clients begin by submitting a request including aircraft category, preferred date, and routing. We will provide availability and a non-binding quote based on current aircraft positioning. Confirmation is subject to aircraft availability at the time of signature and payment. Fixed charter packages shown on the platform are not directly bookable unless explicitly marked as "Direct Booking" and connected to Stripe. In all other cases, availability will be reconfirmed individually.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">2. Smart Contract & Blockchain Transparency</h2>
                <p className="text-gray-600">
                  Bookings may be recorded on blockchain infrastructure to provide immutable proof of transaction and ensure data security. Client identity, payment hashes, and flight details remain confidential and are stored in compliance with applicable data protection laws.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">3. Payment Terms</h2>
                <p className="text-gray-600">
                  We accept payments via Swiss bank account (for European and Swiss clients), Stripe (for international card payments), and selected cryptocurrencies (BTC, ETH, USDC, USDT, SUI and more). Refunds are issued using the same method of payment unless otherwise agreed. Quotes include all operational fees and applicable taxes. No hidden charges apply.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">4. Emptyleg Rules</h2>
                <p className="text-gray-600">
                  Emptyleg offers are only confirmed upon receipt of full payment. Due to dynamic scheduling and limited availability, Emptylegs are subject to change. If the requested Emptyleg is no longer available, PrivatecharterX will issue a full refund within 24 hours or offer an alternative routing if preferred by the client.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">5. Identification Documents</h2>
                <p className="text-gray-600">
                  For regulatory and security purposes, all passengers must provide passport or ID copies at least 48 hours prior to departure.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">6. Insurance</h2>
                <p className="text-gray-600">
                  Flights are operated by licensed carriers under international conventions such as the Montreal or Warsaw Convention. Each operator guarantees that insurance coverage meets or exceeds the required standards.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">7. Cancellations</h2>
                <div className="bg-gray-50 p-4 rounded-xl space-y-2">
                  <p className="text-gray-600">More than 60 days before departure: 30% fee</p>
                  <p className="text-gray-600">60 to 30 days before departure: 40% fee</p>
                  <p className="text-gray-600">30 to 7 days before departure: 50% fee</p>
                  <p className="text-gray-600">Less than 48 hours: 100% fee</p>
                </div>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">8. Delays, Force Majeure & Aircraft Substitution</h2>
                <p className="text-gray-600">
                  Delays due to weather, technical issues or force majeure may lead to revised departure or arrival times. PrivatecharterX will coordinate substitute aircraft where possible. Liability for external delays or cancellations is excluded.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">9. Additional Services</h2>
                <ul className="list-disc list-inside space-y-2 text-gray-600 ml-4">
                  <li>VIP ground transport</li>
                  <li>Concierge coordination</li>
                  <li>Yacht bookings (where available)</li>
                  <li>Special onboard requests</li>
                </ul>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">10. Compliance & Jurisdiction</h2>
                <p className="text-gray-600">
                  PrivatecharterX complies with all applicable aviation, tax, anti-money laundering and data protection regulations. Legal jurisdiction for disputes is Zurich, Switzerland unless otherwise stated in writing.
                </p>
              </div>

              <div className="space-y-4">
                <h2 className="text-xl font-semibold">Contact</h2>
                <p className="text-gray-600">
                  For any inquiries, please contact us via <a href="mailto:info@privatecharterx.com" className="text-black hover:underline">info@privatecharterx.com</a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
